const apis = {
    post_save_debit_note: '/generacion/comprobantes/ebox/nota/debito',
    post_generate_ride: '/core/generacion/comprobantes/ebox/ride/nota/debito',
    get_secuencial_user: '/asignacion/secuencial/usuario/secuencial'
};

export default apis;